import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { hosClockViolationRefs } from "../subjects/hosClockViolation/refs";
import { HosClockHoursSchema } from "./breakOverdue";

/**
 * The driver's duty window ran out.
 */
export const dutyWindowExceededV1 = tmsEventKind(
  { category: "hoursOfService", kind: "dutyWindowExceeded", version: 1 },
  {
    refs: hosClockViolationRefs,
    facts: {
      /** The clock's length in hours, as the vendor labels it. */
      clockHours: HosClockHoursSchema,
    },
  },
);

export const DutyWindowExceededV1Schema = dutyWindowExceededV1.schema;
export const DutyWindowExceededV1FactsSchema = dutyWindowExceededV1.facts;

export type DutyWindowExceededV1 = z.infer<typeof DutyWindowExceededV1Schema>;
export type DutyWindowExceededV1Facts = z.infer<typeof DutyWindowExceededV1FactsSchema>;

/** Every version of `dutyWindowExceeded`, keyed by version. What `catalog.ts` places under `hoursOfService`. */
export const dutyWindowExceeded = { 1: dutyWindowExceededV1 } as const;
